import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign "ResizeObserver loop" errors so the CRA dev overlay does not
// block interaction (triggered by Radix Select/Popover inside tables/dialogs).
const _roErr = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (e.message && _roErr.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
